import { render, staticRenderFns } from "./GamePlayerRow.vue?vue&type=template&id=46a6a6be&scoped=true"
import script from "./GamePlayerRow.vue?vue&type=script&lang=js"
export * from "./GamePlayerRow.vue?vue&type=script&lang=js"
import style0 from "./GamePlayerRow.vue?vue&type=style&index=0&id=46a6a6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6a6be",
  null
  
)

export default component.exports